import { render, staticRenderFns } from "./ContadorInventario.vue?vue&type=template&id=5d2f071a&"
import script from "./ContadorInventario.vue?vue&type=script&lang=js&"
export * from "./ContadorInventario.vue?vue&type=script&lang=js&"
import style0 from "./ContadorInventario.vue?vue&type=style&index=0&id=5d2f071a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports